export default __webpack_public_path__ + "9be0856949d68292afb35db633db9340.jpg";